import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from  '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {tap,map} from 'rxjs/operators';
import {Module} from '../interface/module';

@Injectable({
  providedIn: 'root'
})
export class ModuleService {
  httpOptions:any;
  headers:any;

  private _refreshNeeded$ = new Subject<void>();

  get refreshNeeded$() {
    return this._refreshNeeded$;
  }

  constructor(private http:HttpClient) 
    {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          'Authorization': 'my-auth-token'
        })
      };
  }
 
// Create Module | Update Module
  postModule(url,param){
      return this.http.post<Module>(url,param,this.httpOptions)
      .pipe(
        tap(() =>  {
          this._refreshNeeded$.next();
        })
      );
   }

   getAllModule(url){
    return this.http.get(url,this.httpOptions)
    }

  getModuleByProgramID(url,param){
    return this.http.post(url,param,this.httpOptions)
   }

   

  getModuleByID(url,param){
    return this.http.post<Module>(url,param,this.httpOptions)
  }
  
  
  updateModule(url,param){
    return this.http.put<Module>(url,param,this.httpOptions)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }
  
  deleteModuleByID(url,param){
    return this.http.put<Module>(url,param,this.httpOptions)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }


// GetFilterModule(url){
//   return this.http.get(url,this.httpOptions).pipe(
//     map(items => {
//       return items.filter(items => items === 2);
//     }, error => error)
//   );
// }





 

}

